export default function NotFound() {
  return (
      <center>
    <div style={{ padding: "2rem" }}>
      <h1>Weylend-Yutani Corp - "Building Better Worlds." <br/> Just... not this one</h1><br /><br />
      <p>
<h2>
    The resource you requested is no longer on the grid.<br/>
    It may have been:<br/>
    <br/>
    <b>Relocated</b>: Terraforming in progress, new coordinates not found.<br/>
    <b>Classified</b>: Access restricted by Weyland-Yutani Corporate Security.<br/>
    <b>Lost</b>: Last seen near an uncharted derelict. Signals terminated.<br/>
    <br/>
    Suggested actions for company personnel<br/>
    <b>Return to Main Deck</b>: Navigate back to the homepage before the air gets thin.<br/>
    <b>Recalibrate Coordinates</b>: Check the URL for transmission errors.<br/>
    <b>File an Incident Report</b>: Contact support so we can "review" the crew responsible.<br/>
    <br/>
    Unauthorized exploration beyond this point is not recommended.<br/>
    Weyland-Yutani is not liable for any. encounters resulting from incorrect navigation.<br/></h2>        
      </p>
    </div>
    </center>
  );
}
